// @ts-nocheck

import classNames from 'classnames';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import React from 'react';

/**
 * Generic card components
 */
const Card = (props) => {
  const classes = classNames('card-group__card', props.className, {
    'card-group__card--active': props.active,
  });
  const testid = `card-control${props.testid ? `-${props.testid}` : ''}`;
  return (
    <div
      className={classes}
      style={{ width: props.width, height: props.height }}
      onClick={props.onClick}
      data-testid={testid}
    >
      {props.children}
    </div>
  );
};

Card.propTypes = {
  /**
   * callback when on click
   */
  onClick: PropTypes.func,
  /**
   * width of the component
   */
  width: PropTypes.string,
  /**
   * height of the component
   */
  height: PropTypes.string,
  /**
   * test id for automation
   */
  testid: PropTypes.string,
};

Card.defaultProps = {
  onClick: R.identity,
  width: '225px',
  height: '175px',
};

export default Card;
